import { Box, Icon } from '@chakra-ui/react';

import { FaPlus } from 'react-icons/fa6';

import SectionAction from '../../components/SectionAction';
import SectionPanel from '../../components/SectionPanel';
import SectionPlaceholder from '../../components/SectionPlaceholder';

interface ActivitiesProps {
  customerId: string;
}

const Activities = ({ customerId }: ActivitiesProps) => {
  return (
    <SectionPanel
      title="Activities"
      collapsible
      action={<SectionAction label="New Task" icon={<Icon as={FaPlus} />} />}
    >
      <Box data-customer-id={customerId}>
        <SectionPlaceholder label="Activities" />
      </Box>
    </SectionPanel>
  );
};

export default Activities;
